import React from "react";
import { useDispatch } from "react-redux";
import { setSidebarActive } from "reducers/pageReducer";
import { IoMenuOutline } from "react-icons/io5";

function Menu() {
  const dispatch = useDispatch();

  const onMenuPress = () => {
    dispatch(setSidebarActive(true));
  };

  return (
    <button
      type="button"
      className={ClassName.container}
      onClick={onMenuPress}
      aria-label="Open navigation"
    >
      <IoMenuOutline className={ClassName.menu} />
    </button>
  );
}

export default Menu;

const ClassName = {
  container:
    "fixed left-4 top-4 z-30 flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-primaryText shadow-sm xl:hidden",
  menu: "flex w-5 sm:w-7 object contain",
};
